import React from 'react';

const AiNarrativeReportSection = ({ narrative, dataPdfSource = 'ai_narrative' }) => {
  if (!narrative) return null;

  const criticalPillars = Array.isArray(narrative.criticalPillars) ? narrative.criticalPillars.slice(0, 4) : [];
  const navieraComplaints = Array.isArray(narrative.navieraComplaints) ? narrative.navieraComplaints.slice(0, 4) : [];
  const recommendedActions = Array.isArray(narrative.recommendedActions) ? narrative.recommendedActions.slice(0, 5) : [];
  const caveats = Array.isArray(narrative.caveats) ? narrative.caveats.slice(0, 3) : [];

  return (
    <div
      className="bg-gradient-to-br from-brand-deep via-brand-navy to-[#1a3353] rounded-2xl shadow-card text-white p-6 space-y-5"
      data-pdf-break="true"
      data-pdf-source={dataPdfSource}
    >
      <div className="flex flex-col gap-2 border-b border-white/[0.08] pb-4">
        <p className="text-[0.6rem] uppercase text-white/50">Narrativa ejecutiva AI</p>
        <h2 className="text-xl font-bold font-jakarta text-white">{narrative.headline || 'Lectura ejecutiva del período'}</h2>
        {narrative.overview && <p className="text-sm text-white/70 leading-relaxed">{narrative.overview}</p>}
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-xl border border-white/[0.08] bg-white/[0.06] p-4">
          <p className="text-[0.6rem] uppercase text-white/50 mb-2">Evolución</p>
          <p className="text-sm text-white/80 leading-relaxed">{narrative.evolutionInsight}</p>
        </div>
        <div className="rounded-xl border border-white/[0.08] bg-white/[0.06] p-4">
          <p className="text-[0.6rem] uppercase text-white/50 mb-2">Lectura ejecutiva</p>
          <p className="text-sm text-white/80 leading-relaxed">{narrative.executiveNarrative}</p>
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <div className="rounded-xl border border-rose-500/20 bg-rose-500/10 p-4">
          <p className="text-[0.6rem] uppercase text-rose-300 mb-3">Pilares críticos</p>
          <div className="space-y-3">
            {criticalPillars.map((item) => (
              <div key={`${item.name}-${item.reason}`} className="space-y-1">
                <p className="text-sm font-semibold text-white">{item.name} · <span className="font-jakarta">{Number(item.score || 0).toFixed(1)}</span> pts</p>
                <p className="text-xs text-white/60 leading-relaxed">{item.reason}</p>
              </div>
            ))}
          </div>
        </div>
        <div className="rounded-xl border border-amber-500/20 bg-amber-500/10 p-4">
          <p className="text-[0.6rem] uppercase text-amber-300 mb-3">Navieras con mayor fricción</p>
          <div className="space-y-3">
            {navieraComplaints.map((item) => (
              <div key={`${item.name}-${item.evidence}`} className="space-y-1">
                <p className="text-sm font-semibold text-white">{item.name} · Prioridad {item.priority || 'Media'}</p>
                <p className="text-xs text-white/60 leading-relaxed">{item.evidence}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {recommendedActions.length > 0 && (
        <div className="rounded-xl border border-white/[0.08] p-4">
          <p className="text-[0.6rem] uppercase text-white/50 mb-3">Acciones sugeridas</p>
          <ul className="grid gap-2 text-sm text-white/80 md:grid-cols-2">
            {recommendedActions.map((action) => (
              <li key={action} className="flex items-start gap-2">
                <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-brand-glow flex-shrink-0" />
                <span className="leading-relaxed">{action}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {caveats.length > 0 && (
        <p className="rounded-xl bg-white/[0.05] border border-white/[0.06] px-4 py-3 text-xs leading-relaxed text-white/45">
          {caveats.join(' · ')}
        </p>
      )}
    </div>
  );
};

export default AiNarrativeReportSection;
